import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature roles
import { groupNameLocale } from './constants';
/////////////////////////////////////////////////////

const FLEET_DRIVER_SSN_PERMISSION = 'FLEET_DRIVER_SSN';

const roleTypePermissionDefinitions = {
  [FLEET_DRIVER_SSN_PERMISSION]: {
    group: 'FLEET',
    uiType: 'toggle',
    [GC.FIELD_ROLE_PERMISSION_NAME]: FLEET_DRIVER_SSN_PERMISSION,
    actions: [GC.FIELD_ROLE_USER_PERMISSION_READ, GC.FIELD_ROLE_USER_PERMISSION_WRITE],
  },
};

export const getAllAvailablePermissions = (permissions) => R.filter(
  ({ active, disabled, uiType }) => G.isAllTrue(
    active,
    R.not(disabled),
    R.equals(uiType, 'toggle'),
  ),
  permissions,
);

export const getAllActivePermissionsChecked = R.compose(
  R.all(G.isTrue),
  R.map(R.prop('active')),
  R.values,
);

export const getAllGroupPermissionsChecked = ({ values }, permissions) => {
  const allAvailablePermissions = getAllAvailablePermissions(permissions);
  const allAvailablePermissionsNames = R.map((item) => R.prop('permissionName', item), allAvailablePermissions);

  const allAvailablePermissionsWrite = (item) => R.and(
    R.has(item, values),
    R.equals(R.prop(item, values), GC.FIELD_ROLE_USER_PERMISSION_WRITE),
  );

  const allGroupPermissionsChecked = R.all(allAvailablePermissionsWrite, allAvailablePermissionsNames);

  return allGroupPermissionsChecked;
};

export const getSelectedList = R.compose(
  R.map((item) => item.guid),
  R.filter((item) => G.isTrue(item.selected)),
);

export const mapWithSelectedFalseAndIndexByGuid = R.compose(
  R.indexBy(R.prop('guid')),
  R.map((item) => R.assoc('selected', false, item)),
);

export const getGroupNameLocale = (groupName) => G.getWindowLocale(
  R.path([groupName], groupNameLocale), groupName,
);

export const getAvailableAndDefaultUserPermissions = (defaultPermissions, availablePermissions) => {
  if (R.and(G.isNilOrEmpty(defaultPermissions), G.isNilOrEmpty(availablePermissions))) return [];

  const defaultUserPermissions = R.map((item) =>
    R.assoc('defaultPermission', true, item),
    R.or(defaultPermissions, []),
  );

  const availableUserPermissions = R.map((item) =>
    R.assoc('defaultPermission', false, item),
    R.or(availablePermissions, []),
  );

  return R.compose(
    R.uniqBy(R.prop(GC.FIELD_ROLE_PERMISSION_NAME)),
    R.concat(defaultUserPermissions),
  )(availableUserPermissions);
};

export const getPermissionsWithRoleTypeDefinitions = (permissions, roleTypePermissions) => {
  const configuredRoleTypePermissions = R.compose(
    R.map((permission) => R.mergeRight(
      R.pathOr({}, [R.prop(GC.FIELD_ROLE_PERMISSION_NAME, permission)], roleTypePermissionDefinitions),
      permission,
    )),
    R.filter((permission) => R.has(
      R.prop(GC.FIELD_ROLE_PERMISSION_NAME, permission),
      roleTypePermissionDefinitions,
    )),
  )(R.or(roleTypePermissions, []));

  return R.uniqBy(
    R.prop(GC.FIELD_ROLE_PERMISSION_NAME),
    R.concat(R.or(permissions, []), configuredRoleTypePermissions),
  );
};
